module.exports = __webpack_public_path__ + "img/talento_1.ab48a587.png";